@if (account(); as acc) {
  <span class="accountSignature d-flex align-items-center">
    <span
      class="accountSignature_avatar"
      [matTooltip]="acc | accountDisplayName"
      [matTooltipDisabled]="!displayTooltip()"
    >
      {{ acc | accountDisplayName: true }}
    </span>

    @if (!onlyAvatar()) {
      <span class="accountSignature_displayName ms-1">
        {{ acc | accountDisplayName }}
      </span>
    }
  </span>
} @else {
  <mat-icon class="accountSignature_avatar" svgIcon="account-circle" />
}
